import { getTestIds } from 'seagull/utils/TestIds';
import { PdfViewerModal } from "../../PdfViewerModal/pdfViewerModal";
import RichTextViewerModal from "../../RichTextViewerModal";
import { useOverlayContext } from "../../../contexts";
import { useStoreActions } from "../../../store/store-context";
import { QuillViewerModal } from "../QuillViewerModal/QuillViewerModal";
import { jsx as _jsx } from "react/jsx-runtime";
function removePDFsuffix(name) {
  if (name !== null && name !== void 0 && name.toLowerCase().endsWith('.pdf')) {
    return name.slice(0, -4);
  }
  return name;
}
export const {
  UseViewLegalTermsTID
} = getTestIds();
export const useViewLegalTerms = function useViewLegalTerms() {
  let {
    vendorBusinessId
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    api
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  return {
    async viewLegalTerms(selectedOption, sourceId) {
      const {
        name,
        pdfUniqueName,
        richTextContent,
        richTextId
      } = selectedOption;
      if (!name) return;
      if (pdfUniqueName) {
        await overlayContext.showModal({
          content: _ref => {
            let {
              dismissModal
            } = _ref;
            return /*#__PURE__*/_jsx(PdfViewerModal, {
              testId: UseViewLegalTermsTID.PdfViewerModal(),
              title: removePDFsuffix(name),
              getFileUrl: async () => await api.business.getLegalTermsDownloadURL(pdfUniqueName, vendorBusinessId),
              onClose: dismissModal,
              pdfUniqueName: pdfUniqueName
            });
          }
        });
      } else if (selectedOption.contentType === 'quill' && richTextContent) {
        await overlayContext.showModal({
          content: _ref2 => {
            let {
              dismissModal
            } = _ref2;
            return /*#__PURE__*/_jsx(QuillViewerModal, {
              testId: UseViewLegalTermsTID.QuillViewerModal(),
              title: name,
              richTextContent: richTextContent,
              onClose: dismissModal
            });
          }
        });
      } else if (richTextContent || richTextId) {
        await overlayContext.showModal({
          content: _ref3 => {
            let {
              dismissModal
            } = _ref3;
            return /*#__PURE__*/_jsx(RichTextViewerModal, {
              show: true,
              title: removePDFsuffix(name),
              text: richTextContent,
              queryKey: richTextId !== null && richTextId !== void 0 ? richTextId : undefined,
              fetchText: async () => {
                if (sourceId && richTextId) {
                  const {
                    value
                  } = await api.texts.getLegalTermsRichTextContent(sourceId, richTextId);
                  return value;
                }
                return richTextContent;
              },
              onClose: dismissModal
            });
          }
        });
      }
    }
  };
};